import React from "react";
import { InputRangeRow } from "./index";
// Used by Heli KV2008B and Heli KV2019B machines

export default function UpperDeckRow() {
   return (
      <InputRangeRow
         titleProp={"Upper Deck (f=50Hz)"}
         descriptionProp={" r/min"}
         sizeProp={6}
         colSizeProp={6}
         typeProp={"text"}
         minProp={2000}
         maxProp={6500}
         propertyNameProp={"deckUpper"}
         errorDialogueProp={"2,000-6,500 only"}
         floatProp={false}
      />
   );
}
